import { FilteredItem } from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { GetRolesPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/inputs/get-roles-paginated.model';

import {
  ROLE_LIST_FILTER,
  ROLE_LIST_FILTER_NAME_LIST,
} from '../role-list/role-list.config';
import { useRoleListContext } from '../role.context';
import * as css from './role-list-filter-state.module.scss';

export const RoleListFilterStateController = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useRoleListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleRemove = <FilterNameKey extends keyof GetRolesPaginatedModel>(
    filterName: FilterNameKey,
    filterValue: GetRolesPaginatedModel[FilterNameKey],
  ) => {
    setGetPaginatedQueryParameters((current) => {
      const queryParameterValue = current[filterName];

      if (Array.isArray(queryParameterValue) && !Array.isArray(filterValue)) {
        return {
          ...current,
          [filterName]: queryParameterValue.filter(
            (queryParameterValueItem) =>
              queryParameterValueItem !== filterValue,
          ),
        };
      }

      return {
        ...current,
        [filterName]: undefined,
      };
    });
  };

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const filterNameActiveList = ROLE_LIST_FILTER_NAME_LIST.filter(
    (filterName) => getPaginatedQueryParameters[filterName] !== undefined,
  );

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack
      className={css.filtersSection}
      flex={1}
      gap={GapEnum.S}
      justifyContent="space-between"
      alignItems="center">
      <Stack
        direction="row"
        className={css.displayedFiltersSection}
        gap={GapEnum.S}
        alignItems="center"
        flex={1}>
        {filterNameActiveList
          .flatMap((filterName) => {
            const filterValue = getPaginatedQueryParameters[filterName];

            if (filterValue === undefined) {
              return [];
            }

            const FilteredItemComponent =
              ROLE_LIST_FILTER[filterName]?.componentType;

            // Case 1: Query parameter is a set of values
            if (Array.isArray(filterValue)) {
              return filterValue.map((filterValueItem) => {
                if (FilteredItemComponent) {
                  return (
                    <FilteredItemComponent
                      key={`${filterName}-${filterValueItem}`}
                      value={filterValueItem}
                      onRemove={() => handleRemove(filterName, filterValueItem)}
                    />
                  );
                }

                return [
                  <FilteredItem
                    key={`${filterName}-${filterValueItem}`}
                    label={`${filterValueItem}`}
                    onRemove={() => handleRemove(filterName, filterValueItem)}
                  />,
                ];
              });
            }

            // Case 2: Query parameter is a unique value
            if (FilteredItemComponent) {
              return [
                <FilteredItemComponent
                  key={filterName}
                  value={filterValue}
                  onRemove={() => handleRemove(filterName, filterValue)}
                />,
              ];
            }

            return [
              <FilteredItem
                key={filterName}
                label={`${filterValue}`}
                onRemove={() => handleRemove(filterName, filterValue)}
              />,
            ];
          })
          .slice(0, 3)}
      </Stack>
    </Stack>
  );
};
